import React from 'react';
import { CONTENT_TYPES } from '../../constants';
import Paragraph from '../../../../paragraph';
import SolidIcon from '../../../../solid-icon';
// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message
const RowItemCompact = ({ text = null, contentType = 'icon-check' }) => {
  const icon = () => {
    switch (contentType) {
      case CONTENT_TYPES['icon-not-available']:
        return <SolidIcon glyph="clear-search" type="error" size={14} strokeWidth={3} />;
      case CONTENT_TYPES['icon-check']:
      default:
        return <SolidIcon glyph="check" type="dark" size={14} strokeWidth={3} />;
    }
  };

  return (
    <div className="ws-ui-plan-row-item-compact">
      <span className="ws-ui-plan-row-item-compact__icon-wrapper">{icon()}</span>
      {text && <Paragraph>{text}</Paragraph>}
    </div>
  );
};

export default RowItemCompact;
